import achirdDe from '../../../../assets/assistant/voices/achird-de.mp3';
import achirdEn from '../../../../assets/assistant/voices/achird-en.mp3';
import achirdEs from '../../../../assets/assistant/voices/achird-es.mp3';
import achirdFr from '../../../../assets/assistant/voices/achird-fr.mp3';
import ledaDe from '../../../../assets/assistant/voices/leda-de.mp3';
import ledaEn from '../../../../assets/assistant/voices/leda-en.mp3';
import ledaEs from '../../../../assets/assistant/voices/leda-es.mp3';
import ledaFr from '../../../../assets/assistant/voices/leda-fr.mp3';
import sadaltagerDe from '../../../../assets/assistant/voices/sadaltager-de.mp3';
import sadaltagerEn from '../../../../assets/assistant/voices/sadaltager-en.mp3';
import sadaltagerEs from '../../../../assets/assistant/voices/sadaltager-es.mp3';
import sadaltagerFr from '../../../../assets/assistant/voices/sadaltager-fr.mp3';
import vindemiatrixDe from '../../../../assets/assistant/voices/vindemiatrix-de.mp3';
import vindemiatrixEn from '../../../../assets/assistant/voices/vindemiatrix-en.mp3';
import vindemiatrixEs from '../../../../assets/assistant/voices/vindemiatrix-es.mp3';
import vindemiatrixFr from '../../../../assets/assistant/voices/vindemiatrix-fr.mp3';
import {
	type GeminiVoice,
	PODCAST_VOICE_ORDER,
	PodcastTargetLanguage,
	podcastVoiceNames,
} from './formConfigs';

// Keyed by Gemini voice x target language, so a fifth voice or a fifth language
// is a compile error until its demo files exist. That is the whole point: the
// dropdown and the demo audio derive from one voice list and cannot drift apart.
const VOICE_DEMOS: Record<GeminiVoice, Record<PodcastTargetLanguage, string>> = {
	Leda: {
		[PodcastTargetLanguage.GERMAN]: ledaDe,
		[PodcastTargetLanguage.ENGLISH]: ledaEn,
		[PodcastTargetLanguage.FRENCH]: ledaFr,
		[PodcastTargetLanguage.SPANISH]: ledaEs,
	},
	Achird: {
		[PodcastTargetLanguage.GERMAN]: achirdDe,
		[PodcastTargetLanguage.ENGLISH]: achirdEn,
		[PodcastTargetLanguage.FRENCH]: achirdFr,
		[PodcastTargetLanguage.SPANISH]: achirdEs,
	},
	Vindemiatrix: {
		[PodcastTargetLanguage.GERMAN]: vindemiatrixDe,
		[PodcastTargetLanguage.ENGLISH]: vindemiatrixEn,
		[PodcastTargetLanguage.FRENCH]: vindemiatrixFr,
		[PodcastTargetLanguage.SPANISH]: vindemiatrixEs,
	},
	Sadaltager: {
		[PodcastTargetLanguage.GERMAN]: sadaltagerDe,
		[PodcastTargetLanguage.ENGLISH]: sadaltagerEn,
		[PodcastTargetLanguage.FRENCH]: sadaltagerFr,
		[PodcastTargetLanguage.SPANISH]: sadaltagerEs,
	},
};

// Inverts podcastVoiceNames rather than restating it: the speaker dropdown stores
// the localized name ('Anna'), and only the (name, language) pair identifies a voice.
const voicesByLanguageAndName = Object.values(PodcastTargetLanguage).reduce(
	(index, language) => {
		index[language] = PODCAST_VOICE_ORDER.reduce(
			(names, voice) => {
				names[podcastVoiceNames[voice][language].value] = voice;
				return names;
			},
			{} as Record<string, GeminiVoice>
		);
		return index;
	},
	{} as Record<PodcastTargetLanguage, Record<string, GeminiVoice>>
);

export const voiceForSpeaker = (
	speakerName: string | undefined,
	language: string | undefined
): GeminiVoice | null => {
	if (!speakerName || !language) return null;
	return voicesByLanguageAndName[language as PodcastTargetLanguage]?.[speakerName] ?? null;
};

export const getVoiceDemoSrc = (
	speakerName: string | undefined,
	language: string | undefined
): string | null => {
	const voice = voiceForSpeaker(speakerName, language);
	return voice ? VOICE_DEMOS[voice][language as PodcastTargetLanguage] : null;
};
